/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */

import * as Segment from './segment'

export interface BookmarkRemoved {
	employerUuid?: string
	loggedIn?: boolean
	offeringID?: string
	product?: string
	typedTerm?: string
}
export interface BookmarkSaved {
	employerUuid?: string
	loggedIn?: boolean
	offeringID?: string
	product?: string
	typedTerm?: string
}
export interface CareerOutlookLocationAdded {
	/**
	 * Reference ID for a career
	 */
	careerId?: string
	city?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Reference ID for a Guild program
	 */
	programId?: string
	state?: string
}
export interface CatalogSubNavigation {
	employerUuid?: string
	fromPath?: string
	loggedIn?: boolean
	product?: string
	toPath?: string
	typedTerm?: string
}
export interface ClickApplicationStart {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering where application start was clicked
	 */
	offeringID?: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface Clickable {
	/**
	 * Identifier of application
	 */
	applicationId?: number
	/**
	 * UUID of user's employer (should NOT contain employer name)
	 */
	employer?: string
	/**
	 * Type of error received - used by verification
	 */
	error?: string
	/**
	 * Link if clickable takes user outside of Guild
	 */
	external_url?: string
	/**
	 * Identifier of the institution clicked
	 */
	institutionID?: string
	/**
	 * Location of clickable item
	 */
	location?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn?: boolean
	/**
	 * Identifier of offering of application
	 */
	offeringId?: string
	/**
	 * Product area where event occurred
	 */
	product?: string
	/**
	 * Description of clickable, can include location
	 */
	tag?: string
	/**
	 * Text visible to user on the clickable
	 */
	text?: string
	/**
	 * Is the clickable a link, button, etc
	 */
	type?: string
	/**
	 * Method selected for verification (e.g. phone, email) - used by verification
	 */
	verificationMethodChosen?: string
}
export interface ExperimentViewed {
	audienceId?: any | null
	audienceName?: any | null
	campaignId?: any | null
	campaignName?: any | null
	employerUuid?: string
	experimentId?: any | null
	experimentName?: any | null
	isInCampaignHoldback?: any | null
	loggedIn?: boolean
	nonInteraction?: any | null
	optimizelyUserId?: string
	product?: string
	typedTerm?: string
	variationId?: any | null
	variationName?: any | null
}
export interface FilterAdded {
	employerUuid?: string
	filterCategory?: string
	filterValue?: any[]
	'filterValue.$'?: string
	loggedIn?: boolean
	product?: string
	typedTerm?: string
}
export interface FilterRemoved {
	employerUuid?: string
	filterCategory?: string
	filterValue?: any[]
	'filterValue.$'?: string
	loggedIn?: boolean
	product?: string
	typedTerm?: string
}
export interface FilterUsed {
	employerUuid?: string
	filterCategory?: string
	filterValue?: any[]
	'filterValue.$'?: string
	loggedIn?: boolean
	product?: string
	typedTerm?: string
}
export interface FilterUsedOutset {
	/**
	 * Category of filter
	 */
	filterCategory?: string
	/**
	 * Value added as a filter - Data type Array
	 */
	filterValueArray?: any[]
	/**
	 * Value added as a filter - Data type Object
	 */
	filterValueObject?: Record<string, any>
	/**
	 * Value added as a filter - Data type String
	 */
	filterValueString?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Employer
	 */
	tenant?: string
}
export interface FiltersCleared {
	employerUuid?: string
	loggedIn?: boolean
	product?: string
	typedTerm?: string
}
export interface HomeLayout {
	loggedIn?: boolean
	product?: string
	tag?: string
	weights?: any[]
	'weights.$'?: Record<string, any>
	'weights.$.__typename'?: string
	'weights.$.children'?: any[]
	'weights.$.children.$'?: Record<string, any>
	'weights.$.key'?: string
	'weights.$.weight'?: number
}
export interface InstitutionCardExpanded {
	/**
	 * Identifier of the institution clicked
	 */
	institutionID: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Location of offering when clicked
	 */
	offeringLocation?: string
	/**
	 * Product area where event occurred
	 */
	product: string
	typedTerm?: string
}
export interface OfferingClicked {
	/**
	 * Location of card when offering clicked (e.g. expanded CTA, bar)
	 */
	catalogCardLocation?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn?: boolean
	/**
	 * Identifier of offering clicked
	 */
	offeringID?: string
	/**
	 * Location of offering when click occurred (e.g. gallery, search, quizReco, recoGallery, bookmarks)
	 */
	offeringLocation?: string
	/**
	 * Product area where event occurred
	 */
	product?: string
}
export interface PageViewed {
	details?: string | null
	location?: string
	loggedIn?: boolean | null
	logged_in?: boolean
	path?: string | null
	properties?: Record<string, any> | null
	'properties.loggedIn'?: boolean
	'properties.product'?: string
	referrer?: string | null
	search?: string | null
	tenant?: string
	title?: string | null
	url?: string | null
}
export interface ProgramDetailsImpression {
	employerUuid?: string
	loggedIn?: boolean
	navigationMethod?: string
	offeringID?: string
	product?: string
	text?: string
	typedTerm?: string
}
export interface ProgramQuizCompleted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * List of offering IDs returned with quiz results
	 */
	offeringIDs: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface Search {
	employerUuid?: string
	loggedIn?: boolean
	product?: string
	searchEnterPressed?: boolean
	searchState?: Record<string, any>
	'searchState.pageNumber'?: number
	suggestedProgramClicked?: string
	suggestedTermClicked?: any | null
	typedTerm?: string
	'typedTerm.$'?: string
}
export interface SearchFocused {
	employerUuid?: string
	loggedIn?: boolean
	product?: string
	searchState?: Record<string, any>
	'searchState.pageNumber'?: string
	typedTerm?: string
}
export interface VideoPlaybackStarted {
	''?: Record<string, any>
}
export interface ViewedStudentFundingWidgetState {
	availabilityStatusReason?: string
	loggedIn?: boolean
	product?: string
	state?: string
	tag?: string
}
export interface AccountLoginFail {
	loggedIn?: any | null
	product?: string
}
export interface AccountPasswordResetRequest {
	loggedIn?: any | null
	properties?: Record<string, any>
	'properties.loggedIn'?: boolean
	'properties.product'?: string
}
export interface AccountSignupFailed {
	errorMessage?: string
	loggedIn?: any | null
	product?: string
}
export interface AccountStartSso {
	loggedIn?: any | null
	product?: string
	properties?: any | null
}
export interface AllResults {
	employerUuid?: string
	filters?: string
	loggedIn?: boolean
	nbHits?: number
	product?: string
	programIds?: any[]
	'programIds.$'?: number
	typedTerm?: string
}
export interface ClientAccountCompleted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ClientAccountCreated {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ClientApplicationStart {
	/**
	 * Identifier of application
	 */
	applicationId: number
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering corresponding to application
	 */
	offeringId: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ClientApplicationSubmit {
	/**
	 * Identifier of application
	 */
	applicationId: number
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering corresponding to application
	 */
	offeringId?: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ClientUserProfileCompleted {
	/**
	 * Identifier used to associate a user to an EP
	 */
	employerUuid?: string
	/**
	 * Identifier used to associate a Next Chapter user to an EP
	 */
	entityId?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ClientUserProfileQuestionAttempted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Page Title of question flow
	 */
	pageKey?: string
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Answer field type
	 */
	questionType?: string
}
export interface ClientUserProfileQuestionCompleted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Page Title of question flow
	 */
	pageKey?: string
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Question text
	 */
	questionKey: string
	/**
	 * Answer field type
	 */
	questionType?: string
	/**
	 * User's response to question
	 */
	responseKey?: any | null
	/**
	 * User's response to foreign credentials question (stored separately as questions asked on same page)
	 */
	userResponseForeignEducation?: boolean
	/**
	 * User's response to Prior Education question (stored separately as questions asked on same page)
	 */
	userResponsePriorEducationExperience?: string
}
export interface EnrollmentStatus {
	/**
	 * Is the student currently enrolled at the institution?
	 */
	currentlyEnrolled: boolean
	/**
	 * Name of the institution
	 */
	institution?: string
	/**
	 * Academic Partner Uuid of the institution
	 */
	institutionId?: string
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn?: Record<string, any>
	/**
	 * Product area where event occurred
	 */
	product?: string
	/**
	 * Guild Uuid of the student
	 */
	uuid: string
}
export interface ServerAccountCreated {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ServerAccountLogInSuccess {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product?: string
}
export interface ServerApplicationSectionComplete {
	/**
	 * Identifier of application
	 */
	applicationId: number
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering corresponding to application
	 */
	offeringId: string
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Name of section completed
	 */
	sectionName: string
}
export interface ServerApplicationStart {
	/**
	 * Identifier of application
	 */
	applicationId: number
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering corresponding to application
	 */
	offeringId: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ServerApplicationSubmit {
	/**
	 * Identifier of application
	 */
	applicationId: number
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Identifier of offering corresponding to application
	 */
	offeringId: string
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ServerEmployeeVerificationSuccess {
	employer?: string
	loggedIn?: boolean
	methodUsed?: string
	product?: string
	timestamp?: string
}
export interface ServerUserProfileCompleted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
}
export interface ServerUserProfileQuestionCompleted {
	/**
	 * Was user logged in when this event occurred (T/F)?
	 */
	loggedIn: boolean
	/**
	 * Product area where event occurred
	 */
	product: string
	/**
	 * Question text
	 */
	questionKey: string
	/**
	 * User's response to question
	 */
	userResponse?: any | null
	/**
	 * User's response to foreign credentials question (stored separately as questions asked on same page)
	 */
	userResponseForeignEducation?: boolean
	/**
	 * User's response to Prior Education question (stored separately as questions asked on same page)
	 */
	userResponsePriorEducationExperience?: string
}
export interface UserProgramQuizQuestionAttempted {
	employerUuid?: string
	loggedIn?: boolean
	product?: string
	questionKey?: string
	questionType?: string
	responseKey?: string
	typedTerm?: string
}
export interface UserProgramQuizQuestionCompleted {
	employerUuid?: string
	loggedIn?: boolean
	product?: string
	questionKey?: string
	questionType?: string
	responseKey?: string
	'responseKey.$'?: string
	typedTerm?: string
}

export type ViolationHandler = (
	message: Record<string, any>,
	violations: any[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (
	message,
	violations
) => {
	const msg = JSON.stringify(
		{
			type: 'Typewriter JSON Schema Validation Error',
			description:
				`You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
				'Tracking Plan spec.',
			errors: violations,
		},
		undefined,
		2
	)

	console.warn(msg)
}

let analytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
	return window.analytics
}

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
	/**
	 * Underlying analytics instance where analytics calls are forwarded on to.
	 * Defaults to window.analytics.
	 */
	analytics?: SegmentAnalytics.AnalyticsJS
	/**
	 * Handler fired when if an event does not match its spec. This handler
	 * does not fire in production mode, because it requires inlining the full
	 * JSON Schema spec for each event in your Tracking Plan.
	 *
	 * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
	 * if a message does not match the spec. Otherwise, errors will be logged to stderr.
	 */
	onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
	analytics = options.analytics
		? () => options.analytics || window.analytics
		: analytics
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Segment.Options = {}): Segment.Options {
	return {
		...message,
		context: {
			...(message.context || {}),
			typewriter: {
				language: 'typescript',
				version: '7.4.1',
			},
		},
	}
}

/**
 * @typedef BookmarkRemoved
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [offeringID] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef BookmarkSaved
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [offeringID] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef CareerOutlookLocationAdded
 * @property {string} [careerId] - Reference ID for a career
 * @property {string} [city] -
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 * @property {string} [programId] - Reference ID for a Guild program
 * @property {string} [state] -
 */
/**
 * @typedef CatalogSubNavigation
 * @property {string} [employerUuid] -
 * @property {string} [fromPath] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [toPath] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef ClickApplicationStart
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [offeringID] - Identifier of offering where application start was clicked
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef Clickable
 * @property {number} [applicationId] - Identifier of application
 * @property {string} [employer] - UUID of user's employer (should NOT contain employer name)
 * @property {string} [error] - Type of error received - used by verification
 * @property {string} [external_url] - Link if clickable takes user outside of Guild
 * @property {string} [institutionID] - Identifier of the institution clicked
 * @property {string} [location] - Location of clickable item
 * @property {boolean} [loggedIn] - Was user logged in when this event occurred (T/F)?
 * @property {string} [offeringId] - Identifier of offering of application
 * @property {string} [product] - Product area where event occurred
 * @property {string} [tag] - Description of clickable, can include location
 * @property {string} [text] - Text visible to user on the clickable
 * @property {string} [type] - Is the clickable a link, button, etc
 * @property {string} [verificationMethodChosen] - Method selected for verification (e.g. phone, email) - used by verification
 */
/**
 * @typedef ExperimentViewed
 * @property {any | null} [audienceId] -
 * @property {any | null} [audienceName] -
 * @property {any | null} [campaignId] -
 * @property {any | null} [campaignName] -
 * @property {string} [employerUuid] -
 * @property {any | null} [experimentId] -
 * @property {any | null} [experimentName] -
 * @property {any | null} [isInCampaignHoldback] -
 * @property {boolean} [loggedIn] -
 * @property {any | null} [nonInteraction] -
 * @property {string} [optimizelyUserId] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 * @property {any | null} [variationId] -
 * @property {any | null} [variationName] -
 */
/**
 * @typedef FilterAdded
 * @property {string} [employerUuid] -
 * @property {string} [filterCategory] -
 * @property {any[]} [filterValue] -
 * @property {string} [filterValue.$] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef FilterRemoved
 * @property {string} [employerUuid] -
 * @property {string} [filterCategory] -
 * @property {any[]} [filterValue] -
 * @property {string} [filterValue.$] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef FilterUsed
 * @property {string} [employerUuid] -
 * @property {string} [filterCategory] -
 * @property {any[]} [filterValue] -
 * @property {string} [filterValue.$] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef FilterUsedOutset
 * @property {string} [filterCategory] - Category of filter
 * @property {any[]} [filterValueArray] - Value added as a filter - Data type Array
 * @property {Record<string, any>} [filterValueObject] - Value added as a filter - Data type Object
 * @property {string} [filterValueString] - Value added as a filter - Data type String
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 * @property {string} [tenant] - Employer
 */
/**
 * @typedef FiltersCleared
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef HomeLayout
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [tag] -
 * @property {any[]} [weights] -
 * @property {Record<string, any>} [weights.$] -
 * @property {string} [weights.$.__typename] -
 * @property {any[]} [weights.$.children] -
 * @property {Record<string, any>} [weights.$.children.$] -
 * @property {string} [weights.$.key] -
 * @property {number} [weights.$.weight] -
 */
/**
 * @typedef InstitutionCardExpanded
 * @property {string} institutionID - Identifier of the institution clicked
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [offeringLocation] - Location of offering when clicked
 * @property {string} product - Product area where event occurred
 * @property {string} [typedTerm] -
 */
/**
 * @typedef OfferingClicked
 * @property {string} [catalogCardLocation] - Location of card when offering clicked (e.g. expanded CTA, bar)
 * @property {boolean} [loggedIn] - Was user logged in when this event occurred (T/F)?
 * @property {string} [offeringID] - Identifier of offering clicked
 * @property {string} [offeringLocation] - Location of offering when click occurred (e.g. gallery, search, quizReco, recoGallery, bookmarks)
 * @property {string} [product] - Product area where event occurred
 */
/**
 * @typedef PageViewed
 * @property {string | null} [details] -
 * @property {string} [location] -
 * @property {boolean | null} [loggedIn] -
 * @property {boolean} [logged_in] -
 * @property {string | null} [path] -
 * @property {Record<string, any> | null} [properties] -
 * @property {boolean} [properties.loggedIn] -
 * @property {string} [properties.product] -
 * @property {string | null} [referrer] -
 * @property {string | null} [search] -
 * @property {string} [tenant] -
 * @property {string | null} [title] -
 * @property {string | null} [url] -
 */
/**
 * @typedef ProgramDetailsImpression
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [navigationMethod] -
 * @property {string} [offeringID] -
 * @property {string} [product] -
 * @property {string} [text] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef ProgramQuizCompleted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} offeringIDs - List of offering IDs returned with quiz results
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef Search
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {boolean} [searchEnterPressed] -
 * @property {Record<string, any>} [searchState] -
 * @property {number} [searchState.pageNumber] -
 * @property {string} [suggestedProgramClicked] -
 * @property {any | null} [suggestedTermClicked] -
 * @property {string} [typedTerm] -
 * @property {string} [typedTerm.$] -
 */
/**
 * @typedef SearchFocused
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {Record<string, any>} [searchState] -
 * @property {string} [searchState.pageNumber] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef VideoPlaybackStarted
 * @property {Record<string, any>} [] -
 */
/**
 * @typedef ViewedStudentFundingWidgetState
 * @property {string} [availabilityStatusReason] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [state] -
 * @property {string} [tag] -
 */
/**
 * @typedef AccountLoginFail
 * @property {any | null} [loggedIn] -
 * @property {string} [product] -
 */
/**
 * @typedef AccountPasswordResetRequest
 * @property {any | null} [loggedIn] -
 * @property {Record<string, any>} [properties] -
 * @property {boolean} [properties.loggedIn] -
 * @property {string} [properties.product] -
 */
/**
 * @typedef AccountSignupFailed
 * @property {string} [errorMessage] -
 * @property {any | null} [loggedIn] -
 * @property {string} [product] -
 */
/**
 * @typedef AccountStartSso
 * @property {any | null} [loggedIn] -
 * @property {string} [product] -
 * @property {any | null} [properties] -
 */
/**
 * @typedef AllResults
 * @property {string} [employerUuid] -
 * @property {string} [filters] -
 * @property {boolean} [loggedIn] -
 * @property {number} [nbHits] -
 * @property {string} [product] -
 * @property {any[]} [programIds] -
 * @property {number} [programIds.$] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef ClientAccountCompleted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ClientAccountCreated
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ClientApplicationStart
 * @property {number} applicationId - Identifier of application
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} offeringId - Identifier of offering corresponding to application
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ClientApplicationSubmit
 * @property {number} applicationId - Identifier of application
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [offeringId] - Identifier of offering corresponding to application
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ClientUserProfileCompleted
 * @property {string} [employerUuid] - Identifier used to associate a user to an EP
 * @property {string} [entityId] - Identifier used to associate a Next Chapter user to an EP
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ClientUserProfileQuestionAttempted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [pageKey] - Page Title of question flow
 * @property {string} product - Product area where event occurred
 * @property {string} [questionType] - Answer field type
 */
/**
 * @typedef ClientUserProfileQuestionCompleted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [pageKey] - Page Title of question flow
 * @property {string} product - Product area where event occurred
 * @property {string} questionKey - Question text
 * @property {string} [questionType] - Answer field type
 * @property {any | null} [responseKey] - User's response to question
 * @property {boolean} [userResponseForeignEducation] - User's response to foreign credentials question (stored separately as questions asked on same page)
 * @property {string} [userResponsePriorEducationExperience] - User's response to Prior Education question (stored separately as questions asked on same page)
 */
/**
 * @typedef EnrollmentStatus
 * @property {boolean} currentlyEnrolled - Is the student currently enrolled at the institution?
 * @property {string} [institution] - Name of the institution
 * @property {string} [institutionId] - Academic Partner Uuid of the institution
 * @property {Record<string, any>} [loggedIn] - Was user logged in when this event occurred (T/F)?
 * @property {string} [product] - Product area where event occurred
 * @property {string} uuid - Guild Uuid of the student
 */
/**
 * @typedef ServerAccountCreated
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ServerAccountLogInSuccess
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} [product] - Product area where event occurred
 */
/**
 * @typedef ServerApplicationSectionComplete
 * @property {number} applicationId - Identifier of application
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} offeringId - Identifier of offering corresponding to application
 * @property {string} product - Product area where event occurred
 * @property {string} sectionName - Name of section completed
 */
/**
 * @typedef ServerApplicationStart
 * @property {number} applicationId - Identifier of application
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} offeringId - Identifier of offering corresponding to application
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ServerApplicationSubmit
 * @property {number} applicationId - Identifier of application
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} offeringId - Identifier of offering corresponding to application
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ServerEmployeeVerificationSuccess
 * @property {string} [employer] -
 * @property {boolean} [loggedIn] -
 * @property {string} [methodUsed] -
 * @property {string} [product] -
 * @property {string} [timestamp] -
 */
/**
 * @typedef ServerUserProfileCompleted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 */
/**
 * @typedef ServerUserProfileQuestionCompleted
 * @property {boolean} loggedIn - Was user logged in when this event occurred (T/F)?
 * @property {string} product - Product area where event occurred
 * @property {string} questionKey - Question text
 * @property {any | null} [userResponse] - User's response to question
 * @property {boolean} [userResponseForeignEducation] - User's response to foreign credentials question (stored separately as questions asked on same page)
 * @property {string} [userResponsePriorEducationExperience] - User's response to Prior Education question (stored separately as questions asked on same page)
 */
/**
 * @typedef UserProgramQuizQuestionAttempted
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [questionKey] -
 * @property {string} [questionType] -
 * @property {string} [responseKey] -
 * @property {string} [typedTerm] -
 */
/**
 * @typedef UserProgramQuizQuestionCompleted
 * @property {string} [employerUuid] -
 * @property {boolean} [loggedIn] -
 * @property {string} [product] -
 * @property {string} [questionKey] -
 * @property {string} [questionType] -
 * @property {string} [responseKey] -
 * @property {string} [responseKey.$] -
 * @property {string} [typedTerm] -
 */

/**
 * Bookmark for a program removed in Catalog
 *
 * @param {BookmarkRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bookmarkRemoved(
	props?: BookmarkRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'BookmarkRemoved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Bookmark for a program added in Catalog.
 *
 * @param {BookmarkSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bookmarkSaved(
	props?: BookmarkSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'BookmarkSaved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Location added within the Career Outlook UI to filter only careers within a close proximity of the user.
 *
 * @param {CareerOutlookLocationAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function careerOutlookLocationAdded(
	props: CareerOutlookLocationAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'CareerOutlookLocationAdded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sub-headers in catalog of all-programs, recommended, and bookmarks. (should probably be a manual "page" call)
 *
 * @param {CatalogSubNavigation} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSubNavigation(
	props?: CatalogSubNavigation,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'CatalogSubNavigation',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Application Start CTA is clicked by user
 *
 * @param {ClickApplicationStart} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickApplicationStart(
	props: ClickApplicationStart,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'ClickApplicationStart',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Widely used Clickable Event
 *
 * @param {Clickable} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickable(
	props?: Clickable,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Clickable', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Used for tracking Optimizely experiments.
 *
 * @param {ExperimentViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function experimentViewed(
	props?: ExperimentViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Experiment Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Filter added in the catalog
 *
 * @param {FilterAdded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterAdded(
	props?: FilterAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'FilterAdded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Removing a filter in the catalog
 *
 * @param {FilterRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterRemoved(
	props?: FilterRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'FilterRemoved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Filter added OR removed in the catalog
 *
 * @param {FilterUsed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterUsed(
	props?: FilterUsed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('FilterUsed', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Outset Only: Filter applied to job catalog
 *
 * @param {FilterUsedOutset} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterUsedOutset(
	props: FilterUsedOutset,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'FilterUsed_outset',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * If the user hits the "clear filters" button in catalog
 *
 * @param {FiltersCleared} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filtersCleared(
	props?: FiltersCleared,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'FiltersCleared',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Details about the user's Home page layout.
 *
 * @param {HomeLayout} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function homeLayout(
	props?: HomeLayout,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('HomeLayout', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Track engagement of users on an institution card within the affiliate experience
 *
 * @param {InstitutionCardExpanded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function institutionCardExpanded(
	props: InstitutionCardExpanded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'InstitutionCardExpanded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Offering card is clicked
 *
 * @param {OfferingClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function offeringClicked(
	props?: OfferingClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'OfferingClicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The base "page" call.
 *
 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(
	props?: PageViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Represents the left navigation of the program page. Fires when the member gets to that section of the page either by scrolling or clicking.
 *
 * @param {ProgramDetailsImpression} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function programDetailsImpression(
	props?: ProgramDetailsImpression,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'ProgramDetailsImpression',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Program Quiz Completed
 *
 * @param {ProgramQuizCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function programQuizCompleted(
	props: ProgramQuizCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'ProgramQuizCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Each time a search is executed in Catalog. This is effectively every keypress.
 *
 * @param {Search} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function search(
	props?: Search,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Search', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * When the user clicks into the catalog search box
 *
 * @param {SearchFocused} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFocused(
	props?: SearchFocused,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SearchFocused',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Video Playback Paused' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function videoPlaybackPaused(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Video Playback Paused',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Video Playback Started' track call.
 *
 * @param {VideoPlaybackStarted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function videoPlaybackStarted(
	props?: VideoPlaybackStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Video Playback Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Info related to the funding widget for when the user sees it on Home.
 *
 * @param {ViewedStudentFundingWidgetState} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedStudentFundingWidgetState(
	props?: ViewedStudentFundingWidgetState,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'ViewedStudentFundingWidgetState',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user incorrectly enters a password.
 *
 * @param {AccountLoginFail} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountLoginFail(
	props?: AccountLoginFail,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'accountLoginFail',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user submits the forgot password form.
 *
 * @param {AccountPasswordResetRequest} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountPasswordResetRequest(
	props?: AccountPasswordResetRequest,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'accountPasswordResetRequest',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * If the account creation fails. Usually this is because the account already exists.
 *
 * @param {AccountSignupFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountSignupFailed(
	props?: AccountSignupFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'accountSignupFailed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sent when the user clicks the "Log in with SSO" button from our login page.
 *
 * @param {AccountStartSso} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountStartSso(
	props?: AccountStartSso,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'accountStartSSO',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The results of a query when a user searches in catalog
 *
 * @param {AllResults} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function allResults(
	props?: AllResults,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('allResults', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Dupe of server side account completed (only use for FB conversions/Optly)
 *
 * @param {ClientAccountCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientAccountCompleted(
	props: ClientAccountCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientAccountCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Dupe of server side account created (only use for FB conversions/Optly)
 *
 * @param {ClientAccountCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientAccountCreated(
	props: ClientAccountCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientAccountCreated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User starts an application (First page of application loaded)
 *
 * @param {ClientApplicationStart} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientApplicationStart(
	props: ClientApplicationStart,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientApplicationStart',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User submits an application.
 *
 * @param {ClientApplicationSubmit} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientApplicationSubmit(
	props: ClientApplicationSubmit,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientApplicationSubmit',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Dupe of server side profile completion event (only use for FB conversions & Optly)
 *
 * @param {ClientUserProfileCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientUserProfileCompleted(
	props: ClientUserProfileCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientUserProfileCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Every time a user sees a profile question/attempts to answer
 *
 * @param {ClientUserProfileQuestionAttempted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientUserProfileQuestionAttempted(
	props: ClientUserProfileQuestionAttempted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientUserProfileQuestionAttempted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Every time a user answers a profile completion question
 *
 * @param {ClientUserProfileQuestionCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clientUserProfileQuestionCompleted(
	props: ClientUserProfileQuestionCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clientUserProfileQuestionCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track enrollment of a student in an institution
 *
 * @param {EnrollmentStatus} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enrollmentStatus(
	props: EnrollmentStatus,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'enrollmentStatus',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Account Created Event from the server
 *
 * @param {ServerAccountCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverAccountCreated(
	props: ServerAccountCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverAccountCreated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired every time a user logs in successfully. Note: with sso this can be fired frequently (which is accurate...)
 *
 * @param {ServerAccountLogInSuccess} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverAccountLogInSuccess(
	props: ServerAccountLogInSuccess,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverAccountLogInSuccess',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User completes a section of the application.
 *
 * @param {ServerApplicationSectionComplete} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverApplicationSectionComplete(
	props: ServerApplicationSectionComplete,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverApplicationSectionComplete',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User starts an application
 *
 * @param {ServerApplicationStart} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverApplicationStart(
	props: ServerApplicationStart,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverApplicationStart',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User submits an application
 *
 * @param {ServerApplicationSubmit} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverApplicationSubmit(
	props: ServerApplicationSubmit,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverApplicationSubmit',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sent when the user has successful verified their account through the EVS flow. Not sent for SSO users.
 *
 * @param {ServerEmployeeVerificationSuccess} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverEmployeeVerificationSuccess(
	props?: ServerEmployeeVerificationSuccess,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverEmployeeVerificationSuccess',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event which fires when user completes profile
 *
 * @param {ServerUserProfileCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverUserProfileCompleted(
	props: ServerUserProfileCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverUserProfileCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Every time a user answers a profile completion question
 *
 * @param {ServerUserProfileQuestionCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function serverUserProfileQuestionCompleted(
	props: ServerUserProfileQuestionCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'serverUserProfileQuestionCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user gets to a program quiz question
 *
 * @param {UserProgramQuizQuestionAttempted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userProgramQuizQuestionAttempted(
	props?: UserProgramQuizQuestionAttempted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'userProgramQuizQuestionAttempted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user answer a program quiz question
 *
 * @param {UserProgramQuizQuestionCompleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userProgramQuizQuestionCompleted(
	props?: UserProgramQuizQuestionCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'userProgramQuizQuestionCompleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}

const clientAPI = {
	/**
	 * Updates the run-time configuration of this Typewriter client.
	 *
	 * @param {TypewriterOptions} options - the options to upsert
	 *
	 * @typedef {Object} TypewriterOptions
	 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
	 * 		calls are forwarded on to. Defaults to window.analytics.
	 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
	 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
	 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
	 * 		will be logged to stderr.
	 */
	setTypewriterOptions,
	/**
	 * Bookmark for a program removed in Catalog
	 *
	 * @param {BookmarkRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	bookmarkRemoved,
	/**
	 * Bookmark for a program added in Catalog.
	 *
	 * @param {BookmarkSaved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	bookmarkSaved,
	/**
	 * Location added within the Career Outlook UI to filter only careers within a close proximity of the user.
	 *
	 * @param {CareerOutlookLocationAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	careerOutlookLocationAdded,
	/**
	 * Sub-headers in catalog of all-programs, recommended, and bookmarks. (should probably be a manual "page" call)
	 *
	 * @param {CatalogSubNavigation} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSubNavigation,
	/**
	 * Application Start CTA is clicked by user
	 *
	 * @param {ClickApplicationStart} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickApplicationStart,
	/**
	 * Widely used Clickable Event
	 *
	 * @param {Clickable} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickable,
	/**
	 * Used for tracking Optimizely experiments.
	 *
	 * @param {ExperimentViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	experimentViewed,
	/**
	 * Filter added in the catalog
	 *
	 * @param {FilterAdded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterAdded,
	/**
	 * Removing a filter in the catalog
	 *
	 * @param {FilterRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterRemoved,
	/**
	 * Filter added OR removed in the catalog
	 *
	 * @param {FilterUsed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterUsed,
	/**
	 * Outset Only: Filter applied to job catalog
	 *
	 * @param {FilterUsedOutset} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterUsedOutset,
	/**
	 * If the user hits the "clear filters" button in catalog
	 *
	 * @param {FiltersCleared} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filtersCleared,
	/**
	 * Details about the user's Home page layout.
	 *
	 * @param {HomeLayout} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	homeLayout,
	/**
	 * Track engagement of users on an institution card within the affiliate experience
	 *
	 * @param {InstitutionCardExpanded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	institutionCardExpanded,
	/**
	 * Offering card is clicked
	 *
	 * @param {OfferingClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	offeringClicked,
	/**
	 * The base "page" call.
	 *
	 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pageViewed,
	/**
	 * Represents the left navigation of the program page. Fires when the member gets to that section of the page either by scrolling or clicking.
	 *
	 * @param {ProgramDetailsImpression} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	programDetailsImpression,
	/**
	 * Program Quiz Completed
	 *
	 * @param {ProgramQuizCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	programQuizCompleted,
	/**
	 * Each time a search is executed in Catalog. This is effectively every keypress.
	 *
	 * @param {Search} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	search,
	/**
	 * When the user clicks into the catalog search box
	 *
	 * @param {SearchFocused} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	searchFocused,
	/**
	 * Fires a 'Video Playback Paused' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	videoPlaybackPaused,
	/**
	 * Fires a 'Video Playback Started' track call.
	 *
	 * @param {VideoPlaybackStarted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	videoPlaybackStarted,
	/**
	 * Info related to the funding widget for when the user sees it on Home.
	 *
	 * @param {ViewedStudentFundingWidgetState} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewedStudentFundingWidgetState,
	/**
	 * Fired when a user incorrectly enters a password.
	 *
	 * @param {AccountLoginFail} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountLoginFail,
	/**
	 * Fired when a user submits the forgot password form.
	 *
	 * @param {AccountPasswordResetRequest} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountPasswordResetRequest,
	/**
	 * If the account creation fails. Usually this is because the account already exists.
	 *
	 * @param {AccountSignupFailed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountSignupFailed,
	/**
	 * Sent when the user clicks the "Log in with SSO" button from our login page.
	 *
	 * @param {AccountStartSso} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountStartSso,
	/**
	 * The results of a query when a user searches in catalog
	 *
	 * @param {AllResults} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	allResults,
	/**
	 * Dupe of server side account completed (only use for FB conversions/Optly)
	 *
	 * @param {ClientAccountCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientAccountCompleted,
	/**
	 * Dupe of server side account created (only use for FB conversions/Optly)
	 *
	 * @param {ClientAccountCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientAccountCreated,
	/**
	 * User starts an application (First page of application loaded)
	 *
	 * @param {ClientApplicationStart} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientApplicationStart,
	/**
	 * User submits an application.
	 *
	 * @param {ClientApplicationSubmit} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientApplicationSubmit,
	/**
	 * Dupe of server side profile completion event (only use for FB conversions & Optly)
	 *
	 * @param {ClientUserProfileCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientUserProfileCompleted,
	/**
	 * Every time a user sees a profile question/attempts to answer
	 *
	 * @param {ClientUserProfileQuestionAttempted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientUserProfileQuestionAttempted,
	/**
	 * Every time a user answers a profile completion question
	 *
	 * @param {ClientUserProfileQuestionCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clientUserProfileQuestionCompleted,
	/**
	 * Track enrollment of a student in an institution
	 *
	 * @param {EnrollmentStatus} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enrollmentStatus,
	/**
	 * Account Created Event from the server
	 *
	 * @param {ServerAccountCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverAccountCreated,
	/**
	 * Fired every time a user logs in successfully. Note: with sso this can be fired frequently (which is accurate...)
	 *
	 * @param {ServerAccountLogInSuccess} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverAccountLogInSuccess,
	/**
	 * User completes a section of the application.
	 *
	 * @param {ServerApplicationSectionComplete} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverApplicationSectionComplete,
	/**
	 * User starts an application
	 *
	 * @param {ServerApplicationStart} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverApplicationStart,
	/**
	 * User submits an application
	 *
	 * @param {ServerApplicationSubmit} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverApplicationSubmit,
	/**
	 * Sent when the user has successful verified their account through the EVS flow. Not sent for SSO users.
	 *
	 * @param {ServerEmployeeVerificationSuccess} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverEmployeeVerificationSuccess,
	/**
	 * Event which fires when user completes profile
	 *
	 * @param {ServerUserProfileCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverUserProfileCompleted,
	/**
	 * Every time a user answers a profile completion question
	 *
	 * @param {ServerUserProfileQuestionCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	serverUserProfileQuestionCompleted,
	/**
	 * When a user gets to a program quiz question
	 *
	 * @param {UserProgramQuizQuestionAttempted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userProgramQuizQuestionAttempted,
	/**
	 * When a user answer a program quiz question
	 *
	 * @param {UserProgramQuizQuestionCompleted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userProgramQuizQuestionCompleted,
}

export default new Proxy<typeof clientAPI>(clientAPI, {
	get(target, method) {
		if (typeof method === 'string' && target.hasOwnProperty(method)) {
			return target[method as keyof typeof clientAPI]
		}

		return () => {
			console.warn(`⚠️  You made an analytics call (${String(
				method
			)}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/guildeducation/protocols/tracking-plans/rs_1TWg6M6B6M7F8eSeAUwzP6CQwVs`)
			const a = analytics()
			if (a) {
				a.track(
					'Unknown Analytics Call Fired',
					{
						method,
					},
					withTypewriterContext()
				)
			}
		}
	},
})
